<template>
	<span class="badge-lp" v-if="isLpEnabled" v-tooltip="'Landing page'">
        <img src="https://cdn.ostock.id/icons/landing_page.svg" alt="" srcset="">
    </span>
</template>

<script>
export default {
	name: 'BadgeLp',
	props: {
		isLpEnabled: {
			type: Boolean,
			default: false,
		},
	},
};
</script>

<style scoped>
.badge-lp img {
    width: 20px;
}
</style>
